<template>
<v-card
  color="grey lighten-4"
  flat>
  <v-toolbar :color="color" dark>
    <v-toolbar-title>{{toolbarTitle}}</v-toolbar-title>
  </v-toolbar>
  <v-card-text>
    <span>점검 시각 : {{ date }}</span><br>
    <span>점검 위치 : {{ address }}</span><br>
    <br>

    <v-layout>
      <v-flex xs6 pa2>
        충전기(좌)
        <ul>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '주전원')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '타이머')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '충전케이블')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '하단스위치')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '공기주입기')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(좌)'], '기타')"></li>
        </ul>
      </v-flex>
      <v-flex xs6>
        충전기(우)
        <ul>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '주전원')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '타이머')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '충전케이블')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '핸드폰충전')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '청소에어')"></li>
          <li v-html="$_getCheckResultHtml(report.checkItems['충전기(우)'], '기타')"></li>
        </ul>
      </v-flex>
    </v-layout>
    <!--
    <template v-for="(value, key) in report.checkItems">
      <span :key="key">{{key}} : {{value}}<br></span>
    </template>
    -->
    <br>
    <span>메모 : {{ report.memo }}</span><br>
    <template v-if="report.pictureUrls">
      사진 :
      <v-icon v-for="url in report.pictureUrls" :key="url" @click="$_windowOpen(url)">photo</v-icon>
    </template>
    <template v-if="isAdmin">
      <br><span>{{ report.id }}</span> : <a @click="$_updateRef(report.id)">updateRef</a> <a @click="$_deleteReport(report.id)">deleteReport</a>
    </template>
  </v-card-text>
</v-card>
</template>

<script>
import moment from 'moment'
import {Util} from '../Util'

export default {
  name: 'ReportCard',
  props: {
    report: {
      type: Object,
      default () {
        return {
          checker: null,
          place: null,
          charger: null
        }
      }
    }
  },
  computed: {
    color () {
      return this.good ? 'primary' : 'warning'
    },
    itemTitle () {
      /*
      if (this.kind === KIND_CHECKER) {
        return (this.report.place ? this.report.place.name : '') +
        ' - ' + (this.report.charger ? this.report.charger.managementNumber : '')
      } else if (this.kind === KIND_PLACE) {
        return (this.report.checker ? this.report.checker.name : '') +
        ' - ' + (this.report.place ? this.report.place.name : '')
      }
      */
      return (this.report.place ? this.report.place.name : '') +
        ' - ' + (this.report.charger ? this.report.charger.managementNumber : '')
    },
    toolbarTitle () {
      /*
      if (this.kind === KIND_CHECKER) {
        return (this.report.place ? this.report.place.name : '') +
        ' - ' + (this.report.charger ? this.report.charger.managementNumber : '') +
        ' - ' + (this.report.checker ? this.report.checker.name : '')
      } else if (this.kind === KIND_PLACE) {
        return (this.report.checker ? this.report.checker.name : '') +
        ' - ' + (this.report.place ? this.report.place.name : '') +
        ' - ' + (this.report.charger ? this.report.charger.managementNumber : '')
      }
      */
      return (this.report.place ? this.report.place.name : '') +
        ' - ' + (this.report.charger ? this.report.charger.managementNumber : '') +
        ' - ' + (this.report.checker ? this.report.checker.name : '')
    },
    good () {
      return this.report.checkResult || false
    },
    date () {
      return moment(this.report.created.toDate()).format('YYYY-MM-DD HH:mm')
    },
    /*
    location () {
      // console.log(gmapApi.maps)
      // return new this.google.maps.LatLng(this.report.location.latitude, this.report.location.longitude)
      return this.report.location
    }
    */
    address () {
      return Util.getReadableReportAddress(this.report)
    },
    isAdmin () {
      return this.$store ? this.$store.state.session.admin : false
    }
  },
  methods: {
    $_getCheckResultHtml (checkItem, key) {
      return key +
          ' : <span style="color:' + (checkItem[key] === '고장' ? 'red' : '') + '">' +
          checkItem[key] + '</span>'
    },
    $_windowOpen (url) {
      window.open(url)
    },
    $_updateRef (reportId) {
      if (reportId) {
        this.$fs.db()
          .collection('reports')
          .doc(reportId)
          .get().then((doc) => {
            console.log(doc)
            const report = doc.data()

            const p1 = report.placeRef.get()
            const p2 = report.chargerRef.get()
            const p3 = report.checkerRef.get()

            Promise.all([p1, p2, p3]).then(([place, charger, checker]) => {
              console.log(place.data(), charger.data(), checker.data())

              return this.$fs.db()
                .collection('reports')
                .doc(doc.id)
                .set({
                  'place': place.data(),
                  'charger': charger.data(),
                  'checker': checker.data()
                }, {merge: true})
            })
              .catch(error => {
                if (error) {
                  console.log(error)
                }
              })
          })
      }
    },
    $_deleteReport (reportId) {
      if (reportId) {
        this.$fs.db()
          .collection('reports')
          .doc(reportId)
          .delete()
          .then(() => {
            console.log('Document successfully deleted!')
          })
          .catch(error => {
            if (error) {
              console.log(error)
            }
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .my-report {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

  .my-report.warning {
    background-color: orange;
    border: 1px solid orange;
  }
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportCard.vue